import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { createDefaultSiteContent, normalizeSiteContent, type SiteContentDoc } from '../utils/siteContent';

const SITE_CONTENT_DOC = doc(db, 'siteContent', 'global');

export function useSiteContent() {
  const [content, setContent] = useState<SiteContentDoc>(createDefaultSiteContent());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      SITE_CONTENT_DOC,
      (snapshot) => {
        if (!snapshot.exists()) {
          setContent(createDefaultSiteContent());
          setLoading(false);
          return;
        }

        setContent(normalizeSiteContent(snapshot.data() as Partial<SiteContentDoc>));
        setLoading(false);
      },
      () => {
        setContent(createDefaultSiteContent());
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { content, loading };
}
